import api from '../api'

export default {
  notifications: async (page) => {
    if (page !== undefined) {
      return api.get('api/notifications?page=' + page)
    } else {
      return api.get('api/notifications')
    }
  },

  notificationsUnread: async () => {
    return api.get('api/notifications?unread=true')
  },
 
  update: async () => {
    return api.put('api/notifications/0')
  }

   // create: async notification => {
  //   return api.post('notifications', notification)
  // },

  // get: async id => {
  //   return api.get('notifications/' + id)
  // },


  // delete: async id => {
  //   return api.delete('notifications/' + id)
  // }
}
